export const messages = {
  en: {
    searchCondition: 'Search Conditions',
    ownerNamePlaceholder: 'Enter owner name',
    invoiceTypePlaceholder: 'Select invoice type',
    personal: 'Personal',
    enterprise: 'Enterprise',
    invoiceHeaderPlaceholder: 'Enter invoice header',
    search: 'Search',
    invoiceHeader: 'Invoice Header',
    add: 'Add',
    serialNumber: 'Serial Number',
    ownerName: 'Owner Name',
    invoiceType: 'Invoice Type',
    taxpayerId: 'Taxpayer ID',
    address: 'Address',
    phone: 'Phone',
    bankAccount: 'Bank Account',
    remark: 'Remark',
    operation: 'Operation',
    modify: 'Modify',
    delete: 'Delete',
    confirmDeleteTitle: 'Confirm Deletion',
    confirmDeleteContent: 'Are you sure to delete this invoice header?',
    cancel: 'Cancel',
    confirmDelete: 'Confirm Delete',
    editTitle: 'Edit',
    requiredInvoiceType: 'Invoice type is required',
    requiredInvoiceHeader: 'Invoice header is required',
    requiredTaxpayerId: 'Taxpayer ID is required',
    requiredAddress: 'Address is required',
    requiredPhone: 'Phone is required',
    requiredBankAccount: 'Bank account is required',
    optionalRemark: 'Remark (optional)',
    save: 'Save',
    addOwnerInvoice: {
      title: 'Add Invoice',
      back: 'Back',
      owner: 'Owner',
      selectOwner: 'Select Owner',
      invoiceType: 'Invoice Type',
      invoiceTitle: 'Invoice Title',
      taxNumber: 'Taxpayer ID',
      address: 'Address',
      phone: 'Phone',
      bankAccount: 'Bank Account',
      remarks: 'Remarks',
      save: 'Save',
      required: 'Required',
      personal: 'Personal',
      enterprise: 'Enterprise',
      placeholder: {
        owner: 'Please select owner',
        invoiceType: 'Please select invoice type',
        invoiceTitle: 'Please enter invoice title',
        taxNumber: 'Please enter taxpayer ID',
        address: 'Please enter address',
        phone: 'Please enter phone number',
        bankAccount: 'Please enter bank account',
        remarks: 'Optional remarks'
      },
      validation: {
        ownerRequired: 'Owner is required',
        typeRequired: 'Invoice type is required',
        titleRequired: 'Invoice title is required',
        taxNumberRequired: 'Taxpayer ID is required',
        addressRequired: 'Address is required',
        phoneRequired: 'Phone is required',
        bankAccountRequired: 'Bank account is required'
      }
    },
  },
  zh: {
    searchCondition: '查询条件',
    ownerNamePlaceholder: '请输入业主名称',
    invoiceTypePlaceholder: '请选择发票类型',
    personal: '个人',
    enterprise: '企业',
    invoiceHeaderPlaceholder: '请输入发票名头',
    search: '查询',
    invoiceHeader: '发票抬头',
    add: '添加',
    serialNumber: '编号',
    ownerName: '业主名称',
    invoiceType: '发票类型',
    taxpayerId: '纳税人识别号',
    address: '地址',
    phone: '电话',
    bankAccount: '开户行及账号',
    remark: '备注',
    operation: '操作',
    modify: '修改',
    delete: '删除',
    confirmDeleteTitle: '请确认您的操作',
    confirmDeleteContent: '确定删除发票抬头',
    cancel: '点错了',
    confirmDelete: '确认删除',
    editTitle: '修改',
    requiredInvoiceType: '必填，请选择发票类型',
    requiredInvoiceHeader: '必填，请填写发票名头',
    requiredTaxpayerId: '必填，请填写纳税人识别号',
    requiredAddress: '必填，请填写地址',
    requiredPhone: '必填，请填写电话',
    requiredBankAccount: '必填，请填写开户行及账号',
    optionalRemark: '选填，请填写备注',
    save: '保存',
    addOwnerInvoice: {
      title: '添加发票抬头',
      back: '返回',
      owner: '业主',
      selectOwner: '选择业主',
      invoiceType: '发票类型',
      invoiceTitle: '发票名头',
      taxNumber: '纳税人识别号',
      address: '地址',
      phone: '电话',
      bankAccount: '开户行及账号',
      remarks: '备注',
      save: '保存',
      required: '必填',
      personal: '个人',
      enterprise: '企业',
      placeholder: {
        owner: '请选择业主',
        invoiceType: '请选择发票类型',
        invoiceTitle: '请填写发票名头',
        taxNumber: '请填写纳税人识别号',
        address: '请填写地址',
        phone: '请填写电话',
        bankAccount: '请填写开户行及账号',
        remarks: '选填备注'
      },
      validation: {
        ownerRequired: '业主不能为空',
        typeRequired: '发票类型不能为空',
        titleRequired: '发票名头不能为空',
        taxNumberRequired: '纳税人识别号不能为空',
        addressRequired: '地址不能为空',
        phoneRequired: '电话不能为空',
        bankAccountRequired: '开户行及账号不能为空'
      }
    },
  }
}